"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "search", {
  enumerable: true,
  get: function get() {
    return _search.default;
  }
});
Object.defineProperty(exports, "volumeFill", {
  enumerable: true,
  get: function get() {
    return _volumeFill.default;
  }
});
var _search = _interopRequireDefault(require("@/assets/icons/page/search.svg?inline"));
var _volumeFill = _interopRequireDefault(require("@/assets/icons/page/volume-fill.svg?inline"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }